import React from 'react';
import { motion } from 'framer-motion';
import { FiPhone, FiMail, FiArrowUp } from 'react-icons/fi';
import { FaWhatsapp } from 'react-icons/fa';
import logo from '../assets/logo.png';

const NAV = [
  { id: 'home', label: 'Home' },
  { id: 'solutions', label: 'Solutions' },
  { id: 'portfolio', label: 'Portfolio' },
  { id: 'industries', label: 'Industries' },
  { id: 'about', label: 'Why SPE' },
  { id: 'future', label: 'Vision' },
  { id: 'contact', label: 'Contact' },
];

const BUSINESS_SOLUTIONS = [
  "Packaging Solutions",
  "Procurement Support",
  "Distribution Services",
  "Strategic Partnerships"
];

export default function Footer() {
  const go = id => document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
  const toTop = () => window.scrollTo({ top: 0, behavior: 'smooth' });
  const year = new Date().getFullYear();

  return (
    <footer style={{
      background: 'linear-gradient(135deg, #0A2540 0%, #102A43 50%, #1F3A5F 100%)',
      color: 'rgba(255,255,255,0.65)'
    }}>
      <div className="container" style={{ paddingTop: '4rem', paddingBottom: '2rem' }}>
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))',
          gap: '3rem',
          paddingBottom: '3rem',
          borderBottom: '1px solid rgba(255,255,255,0.08)'
        }}>

          {/* Brand */}
          <div>
            <div style={{ display: 'flex', alignItems: 'center', gap: '0.8rem', marginBottom: '1.2rem' }}>
              <div style={{ position: 'relative' }}>
                <img src={logo} alt="SPE" style={{ width: 48, height: 48, borderRadius: '50%', objectFit: 'cover' }} />
                <div style={{
                  position: 'absolute',
                  inset: -3,
                  borderRadius: '50%',
                  background: 'linear-gradient(135deg,#E91E8C,#FF6B2B)',
                  opacity: 0.25,
                  filter: 'blur(6px)'
                }} />
              </div>
              <div>
                <p style={{
                  fontFamily: 'var(--font-display)',
                  fontWeight: 700,
                  fontSize: '1.35rem',
                  lineHeight: 1,
                  color: '#fff'
                }}>
                  SPE
                </p>
                <p style={{
                  fontFamily: 'var(--font-body)',
                  fontSize: '0.68rem',
                  letterSpacing: '0.15em',
                  color: 'rgba(255,255,255,0.5)'
                }}>
                  SHREE PARASNATH ENTERPRISES
                </p>
              </div>
            </div>

            <p style={{
              fontFamily: 'var(--font-body)',
              color: 'rgba(255,255,255,0.55)',
              fontSize: '0.92rem',
              lineHeight: 1.65,
              maxWidth: 260
            }}>
              SPE delivers packaging, procurement, and supply solutions that help businesses operate efficiently and scale with confidence.
            </p>

            <div style={{ marginTop: '1.5rem', display: 'flex', gap: '8px', fontSize: '0.8rem', color: 'rgba(255,255,255,0.45)' }}>
              Packaging • Procurement • Distribution
            </div>
          </div>

          {/* Navigation */}
          <div>
            <p style={{
              fontFamily: 'var(--font-body)',
              fontWeight: 700,
              fontSize: '0.72rem',
              color: '#fff',
              textTransform: 'uppercase',
              letterSpacing: '0.12em',
              marginBottom: '1.2rem'
            }}>
              Navigation
            </p>
            {NAV.map(({ id, label }) => (
              <motion.button
                key={id}
                whileHover={{ x: 6, color: '#fff' }}
                onClick={() => go(id)}
                style={{
                  display: 'block',
                  background: 'none',
                  border: 'none',
                  cursor: 'pointer',
                  padding: '0.45rem 0',
                  fontFamily: 'var(--font-body)',
                  fontSize: '0.9rem',
                  color: 'rgba(255,255,255,0.55)',
                  textAlign: 'left',
                  width: '100%'
                }}
              >
                {label}
              </motion.button>
            ))}
          </div>

          {/* Business Contact */}
          <div>
            <p style={{
              fontFamily: 'var(--font-body)',
              fontWeight: 700,
              fontSize: '0.72rem',
              color: '#fff',
              textTransform: 'uppercase',
              letterSpacing: '0.12em',
              marginBottom: '1.2rem'
            }}>
              Business Contact
            </p>

            <a href="tel:+919821991932" style={{ display: 'flex', gap: '0.7rem', marginBottom: '1rem', textDecoration: 'none', color: 'inherit' }}>
              <FiPhone size={18} style={{ color: '#60A5FA', marginTop: 2 }} />
              <span style={{ fontSize: '0.9rem', lineHeight: 1.6 }}>+91 98219 91932</span>
            </a>

            <a href="mailto:info.shreeparasnathenterprises@gmail.com" style={{ display: 'flex', gap: '0.7rem', marginBottom: '1.4rem', textDecoration: 'none', color: 'inherit' }}>
              <FiMail size={18} style={{ color: '#60A5FA', marginTop: 2 }} />
              <span style={{ fontSize: '0.9rem', lineHeight: 1.6, wordBreak: 'break-all' }}>
                info.shreeparasnathenterprises@gmail.com
              </span>
            </a>

            <div>
              <p style={{ fontSize: '0.82rem', fontWeight: 600, marginBottom: '0.4rem' }}>Business Hours</p>
              <p style={{ fontSize: '0.85rem', color: 'rgba(255,255,255,0.5)', lineHeight: 1.55 }}>
                Monday – Saturday<br />
                9:00 AM – 7:00 PM IST
              </p>
            </div>
          </div>

          {/* Business Solutions */}
          <div>
            <p style={{
              fontFamily: 'var(--font-body)',
              fontWeight: 700,
              fontSize: '0.72rem',
              color: '#fff',
              textTransform: 'uppercase',
              letterSpacing: '0.12em',
              marginBottom: '1.2rem'
            }}>
              Business Solutions
            </p>
            {BUSINESS_SOLUTIONS.map((item, i) => (
              <p key={i} style={{
                fontSize: '0.9rem',
                color: 'rgba(255,255,255,0.55)',
                marginBottom: '0.65rem'
              }}>
                {item}
              </p>
            ))}
          </div>
        </div>

        {/* Bottom Bar */}
        <div style={{
          display: 'flex',
          flexWrap: 'wrap',
          justifyContent: 'space-between',
          alignItems: 'center',
          gap: '1rem',
          paddingTop: '2rem',
          fontSize: '0.78rem',
          color: 'rgba(255,255,255,0.35)'
        }}>
          <p>
            © {year} SPE. All rights reserved.
          </p>
          <p style={{ textAlign: 'center' }}>
            Packaging Solutions • Procurement Services • Distribution Support • Business Solutions
          </p>
          <p style={{ fontSize: '0.75rem' }}>
            PAN India • Trusted Partner
          </p>
        </div>
      </div>

      {/* Floating WhatsApp */}
      <motion.a
        href="https://wa.me/919821991932?text=Hello SPE Team! I'd like to discuss my business requirements."
        target="_blank"
        rel="noreferrer"
        animate={{ y: [0, -6, 0] }}
        transition={{ duration: 2.8, repeat: Infinity, ease: 'easeInOut' }}
        whileHover={{ scale: 1.12 }}
        style={{
          position: 'fixed',
          bottom: '1.8rem',
          right: '1.8rem',
          zIndex: 999,
          width: 62,
          height: 62,
          borderRadius: '50%',
          background: 'linear-gradient(135deg,#25D366,#128C7E)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          boxShadow: '0 8px 32px rgba(37,211,102,0.5)',
          textDecoration: 'none'
        }}
      >
        <FaWhatsapp size={28} color="#fff" />
      </motion.a>

      {/* Scroll to Top */}
      <motion.button
        onClick={toTop}
        whileHover={{ scale: 1.1 }}
        whileTap={{ scale: 0.9 }}
        style={{
          position: 'fixed',
          bottom: '1.8rem',
          left: '1.8rem',
          zIndex: 999,
          width: 46,
          height: 46,
          borderRadius: '50%',
          background: 'rgba(255,255,255,0.95)',
          border: '1.5px solid rgba(233,30,140,0.25)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          boxShadow: '0 6px 20px rgba(0,0,0,0.12)',
          cursor: 'pointer',
          color: '#1E40AF'
        }}
      >
        <FiArrowUp size={20} />
      </motion.button>
    </footer>
  );
}